import { Kicker, Reveal } from "@/components/Reveal";
import { useSiteData } from "@/context/SiteData";
import { usePageMeta } from "@/lib/meta";

export default function Policies() {
  usePageMeta("Policies | Diamond's Divine Arts", "Shipping, returns, and refund policies for Diamond's Divine Arts.");
  const { t } = useSiteData();
  const blocks = [
    { title: "Shipping", key: "policy_shipping" },
    { title: "Returns", key: "policy_returns" },
    { title: "Refunds", key: "policy_refund" },
  ];
  return (
    <section className="divine-rays relative overflow-hidden py-16 md:py-24" data-testid="policies-page">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Kicker>Policies</Kicker>
          <h1 className="mt-6 font-serif text-4xl font-light leading-[1.08] tracking-tight text-[#1C1815] sm:text-5xl">
            Shipping, returns & <span className="italic text-[#9A7A3F]">refunds</span>
          </h1>
        </Reveal>
        <div className="mt-12 space-y-12">
          {blocks.map((b, i) => (
            <Reveal key={b.key} delay={i * 0.08}>
              <div className="border-t border-[#D4AF37]/30 pt-8" data-testid={`policy-${b.key}`}>
                <h2 className="font-serif text-2xl text-[#1C1815]">{b.title}</h2>
                <p className="mt-4 whitespace-pre-line text-base font-light leading-relaxed text-[#4A423A]">
                  {t(b.key, "")}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
